<script lang="ts">
  import EditPencilIcon from '$icons/edit/EditPencilIcon.svelte';
  import Button from '$lib/components/reusable/Button.svelte';
  import Notification from '$lib/components/reusable/Notification.svelte';
  // import type { ProfileCompletion, ProfileCompletionField } from '$shared/api';

  // export let profileCompletion: ProfileCompletion;

  // function groupProfileFieldsByCategory(fields: ProfileCompletionField[]) {
  //   return fields.reduce(
  //     (acc, field) => {
  //       if (!acc[field.category]) {
  //         acc[field.category] = [];
  //       }
  //       acc[field.category].push(field);
  //       return acc;
  //     },
  //     {} as Record<string, ProfileCompletionField[]>,
  //   );
  // }
</script>

<Notification
  class="mb-6 w-full"
  warning
  title="Complete your profile"
  description="Fill out your profile information to gain full access to the platform, and to be eligible to compete in any upcoming hackathons."
>
  <div class="flex flex-col gap-2">
    <!-- <ul class="text-gray-dark-12 ml-8 space-y-4 text-sm">
      {#each Object.entries(groupProfileFieldsByCategory(profileCompletion.fields)) as [category, fields]}
        <li>
          <div class="text-gray-dark-11 mb-2 font-semibold">{category}</div>
          <ul class="space-y-2">
            {#each fields as field}
              <li class="flex items-center gap-2">
                <div
                  class={cn(
                    'flex h-4 w-4 items-center justify-center rounded border',
                    field.completed
                      ? 'border-mint-dark-11 bg-mint-dark-11/10'
                      : 'border-gray-dark-11',
                  )}
                >
                  {#if field.completed}
                    <CheckboxTickIcon class="text-gray-dark-11 h-3 w-3" />
                  {/if}
                </div>
                <span class={field.completed ? 'text-gray-dark-11' : 'text-gray-dark-12'}>
                  {field.name}
                </span>
              </li>
            {/each}
          </ul>
        </li>
      {/each}
    </ul> -->
    <Button class="mt-2 w-fit" secondary size="sm" href="/onboarding/profile">
      Complete Profile
      <EditPencilIcon slot="right-icon" class="h-4 w-4" />
    </Button>
  </div>
</Notification>
